import CustomMargin from '../../../components/custom-margin'
import { MailIcon, PhoneIcon, LocationMarkerIcon } from '@heroicons/react/solid'
import { EMAIL_ADD, PHONE, PHONE_NUMBER, LOCATION_ADD } from '../../../components/constants'

export default function ContactHome() {
    return (
        <section className="my-10">
            <CustomMargin>

                <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-zinc-700 via-zinc-300 to-zinc-700 p-[1px] shadow-[0_0_30px_rgba(255,255,255,0.08)]">

                    <div className="relative overflow-hidden rounded-3xl bg-gradient-to-b from-[#181818] via-[#0d0d0d] to-black">

                        {/* Metallic shine */}
                        <div className="absolute inset-0 bg-[linear-gradient(115deg,transparent_15%,rgba(255,255,255,0.06)_45%,transparent_75%)] pointer-events-none" />

                        {/* Top highlight */}
                        <div className="absolute top-0 left-0 h-20 w-full bg-gradient-to-b from-white/5 to-transparent pointer-events-none" />

                        <div className="relative z-10 flex flex-col lg:flex-row">

                            {/* Email */}
                            <a href={`mailto:${EMAIL_ADD}`} className="landing-card landing-card-delay-1 group flex flex-1 flex-col items-center justify-center px-8 py-10 text-center transition duration-300 hover:bg-white/[0.03]">
                                <MailIcon className="h-10 w-10 text-zinc-300 transition group-hover:text-white" />

                                <h2 className="mt-4 font-fontMontserrat text-2xl tracking-[0.2em] text-white">
                                    EMAIL
                                </h2>

                                <div className="my-4 h-px w-12 bg-zinc-600" />

                                <p className="text-zinc-400 break-words">
                                    {EMAIL_ADD}
                                </p>
                            </a>

                            {/* Divider */}
                            <div className="hidden lg:block w-px bg-gradient-to-b from-transparent via-zinc-700 to-transparent" />

                            {/* Visit */}
                            <a
                                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                    LOCATION_ADD
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="landing-card landing-card-delay-2 group flex flex-1 flex-col items-center justify-center px-8 py-10 text-center transition duration-300 hover:bg-white/[0.03]"
                            >
                                <LocationMarkerIcon className="h-10 w-10 text-zinc-300 transition group-hover:text-white" />

                                <h2 className="mt-4 font-fontMontserrat text-2xl tracking-[0.2em] text-white">
                                    VISIT US
                                </h2>

                                <div className="my-4 h-px w-12 bg-zinc-600" />

                                <p className="text-zinc-400">
                                    {LOCATION_ADD}
                                </p>
                            </a>

                            {/* Divider */}
                            <div className="hidden lg:block w-px bg-gradient-to-b from-transparent via-zinc-700 to-transparent" />

                            {/* Phone */}
                            <a href={`tel:${PHONE}`} className="landing-card landing-card-delay-3 group flex flex-1 flex-col items-center justify-center px-8 py-10 text-center transition duration-300 hover:bg-white/[0.03]">
                                <PhoneIcon className="h-10 w-10 text-zinc-300 transition group-hover:text-white" />

                                <h2 className="mt-4 font-fontMontserrat text-2xl tracking-[0.2em] text-white">
                                    PHONE
                                </h2>

                                <div className="my-4 h-px w-12 bg-zinc-600" />

                                <p className="text-zinc-400">
                                    {PHONE_NUMBER}
                                </p>
                            </a>

                        </div>

                    </div>

                </div>

            </CustomMargin>
        </section>
    )
}
